import { useAppInfo } from "shared-ts-app-info";
import { useUser } from "shared-ts-utils-authentication";

export const useAbnormalBurnsPageEnabled = (): boolean => {
  const appInfo = useAppInfo();
  const user = useUser();
  return (
    appInfo.buildVersion === "local-development" || user.isAirmontEmployee()
  );
};
